<template lang="pug">
  #fanfest.bg
    .container-float
        .embed-responsive.embed-responsive-1by1(ref='streamerView')
            // video#myVideoId.embed-responsive-item(autoplay muted playsinline)
    .fixed-bottom(style='height:200px')
      FanFestService(:selfVideoList="videoList" :screenName="organizerID" :shouldMute="true" :canStream="true" :streamButton="streamButton")
</template>

<script>
import axios from "axios";
import Parse from "@/services/parse.js";
import FanFestService from "../components/services/FanFestService.vue";
import webRTCAdapter from 'webrtc-adapter';

export default {
  name: "FanFest",
  data() {
    return {
      organizerID: '',
      groupID: '',
      //isStreaming: false,
      streamButton: null,
      videoList: null
    };
  },
  components: {
    FanFestService
  },
  methods: {
    configFanfest: function() {
      var userID = Parse.User.current().id;
      axios
        .get(`${process.env.VUE_APP_BACKEND}/app/dashboard/${userID}`)
        .then(response => {
          this.organizerID = response.data.organizerID;
          this.groupID = response.data.teamID;
        })
        .catch(() => {
          Parse.User.logOut().then(() => {
            this.$router.push({name: 'login'})
          });
        });
    },
    toggleButton: function() {
    /*   if (!this.isStreaming)
        this.start();
      else
        this.end(); */
    },
    start: function() {
      const self = this;
      self.$refs.publishButton.disabled = true;
      setTimeout(function() {
          self.$refs.publishButton.disabled = false;
      }, 5000);
      
      // fanfestShare.publish(document.getElementById('myVideoId'), this.$route.params.username);
      this.$socket.emit('startFanFest', this.groupID);
      this.isStreaming = true;
    },
    end: function() {
      // fanfestShare.stopPublisher();
      this.$socket.emit('stopFanFest', this.groupID);
      this.isStreaming = false;
    }
  },
  mounted: function() {
    // this.configFanfest();
    console.log('adapter browser: '+webRTCAdapter.browserDetails.browser)
    console.log('adapter version: '+webRTCAdapter.browserDetails.version)
    
    this.organizerID = this.$route.params.username
    this.videoList = {list:this.$refs.streamerView};
    this.streamButton = {button: this.$refs.publishButton};
  },
};
</script>

<style>

video {
  width: 100%;
  height: 100%;
  position:absolute;
  top:0;
  object-fit: cover;
}

.bg {
  height: 100vh;
  background-color: black;
}

</style>
